<template>

	<div class="front-page main" v-if="currentPage">

		<section class="front-full" v-if="currentPage.acf.full_services_items || currentPage.acf.full_projects_items || currentPage.acf.full_machines_items">

			<div class="main-content featured-boxes">
				<fullPosts :data="currentPage.acf.full_services_items || currentPage.acf.full_projects_items || currentPage.acf.full_machines_items" :type="currentPage.acf.full_type"/>
				<p class="section-link" v-if="currentPage.acf.full_link">
					<wpLink 
						:url="currentPage.acf.full_link.url" 
						:title="currentPage.acf.full_link.title"
						:class="currentPage.acf.full_link.class"
						:description="currentPage.acf.full_link.description"
						v-html="currentPage.acf.full_link.title" />
				</p>
			</div>
			
		</section>
		<section class="front-projects main-content" v-if="currentPage.acf.projects_slider && currentPage.acf.projects_slider.title && currentPage.acf.projects_slider.items">
			<h2 class="section-title" v-html="currentPage.acf.projects_slider.title"></h2>
			<projectsSlider :id="[currentPage.acf.projects_slider.items]" :type="'projects'"/>
			<p class="section-link">
				<wpLink 
                    :url="projectsArchive" 
                    :type="true"
                    v-html="currentPage.acf.projects_slider.link_text" />
			</p>
		</section>
		<template v-if="currentPage.acf.posts_archive_title && currentPage.acf.show_section_news">
			<recentPosts :sectionTitle="currentPage.acf.posts_archive_title" :link_text="currentPage.acf.posts_link_text"/>
		</template>

		
	</div>
	
</template>

<script>

import { mapActions, mapMutations } from 'vuex';

import fullPosts from '@/components/modules/FullPosts'
import projectsSlider from '@/components/modules/ProjectsSlider'
import recentPosts from '@/components/modules/RecentPosts'
import wpLink from '@/components/navigation/WpLink'

export default {
	name: 'front-page',
	data() {
		return {
			projectsArchive: '/' + WPVUE.archives.projects.slug,
			servicesArchive: '/' + WPVUE.archives.services.slug,
			machinesArchive: '/' + WPVUE.archives.machines.slug,
			items: '',
		}
	},
	methods: {
		
	},
	computed: {
		
	},
	components:{
		projectsSlider,
		fullPosts,
		wpLink,
		recentPosts
	},
}
</script>
